'use client';

import * as React from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';

const Avatar = ({ className, children, ...props }: React.HTMLAttributes<HTMLSpanElement>) => (
  <div
    className={cn(
      'bg-color-grey flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-full',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

const AvatarIcon = ({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) => (
  <span
    {...props}
    className={cn('text-color-background-base size-4', className || 'icon-emp-avatar')}
  />
);

export { Avatar, AvatarIcon };
